import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const EclipseAiRecommendationStoreExtension = ModuleExtensions.storeExtension({
  isCollapsed: false,
  isRevealed: false,
  recommendedProductId: ''
}, 'aiRecommendationStore', {
  useIsCollapsed: state => state.isCollapsed,
  useIsRevealed: state => state.isRevealed,
  useRecommendedProductId: state => state.recommendedProductId
}, {
  setRecommendedProductId: (_ref, recommendedProductId) => {
    let {
      draft
    } = _ref;
    draft.recommendedProductId = recommendedProductId;
  },
  reveal: _ref2 => {
    let {
      draft
    } = _ref2;
    draft.isRevealed = true;
  },
  collapse: _ref3 => {
    let {
      draft
    } = _ref3;
    draft.isCollapsed = true;
  },
  expand: _ref4 => {
    let {
      draft
    } = _ref4;
    draft.isCollapsed = false;
  }
});
//# sourceMappingURL=aiRecommendationStore.extension.js.map